module.exports = __webpack_public_path__ + "img/feature_manager_ui.59bdce5a.png";